import { GET_CAPABILITIES } from '../constants/MethodNames';
import { callingAPIMethodWithQueue } from '../utils/hsCallingUtils';
export default function getCallingCapabilities() {
  return callingAPIMethodWithQueue(GET_CAPABILITIES);
}